import UiInitialState from 'RLX/State/Ui/UiInitialState';
import SidebarReducer from 'RLX/State/Ui/Sidebar/SidebarReducer';
import { sessionSave as save, sessionLoad as load } from 'Core/Utils/Session';

const UiReducer = (state = UiInitialState, { type, payload } = {}) => {

  state = SidebarReducer(state, { type, payload });

  switch (type) {
    case 'ui/FATAL_ERROR': {
      const broken = true;
      const { errorMessage } = payload;
      return { ...state, broken, errorMessage };
    }

    case 'ui/LOADING_STARTED': {
      const loading = true;
      return { ...state, loading };
    }

    case 'ui/LOADING_FINISHED': {
      const loading = false;
      return { ...state, loading };
    }

    case 'ui/LOADED_INITIAL_STATE': {
      const initialStateLoaded = true;
      return { ...state, initialStateLoaded };
    }

    case 'ui/RESET_BROKEN_FLAG': {
      const broken = false;
      return { ...state, broken };
    }

    case 'ui/CHANGES_MADE': {
      const unsavedChanges = true;
      return { ...state, unsavedChanges };
    }

    case 'ui/CHANGES_SAVED': {
      const unsavedChanges = false;
      return { ...state, unsavedChanges };
    }

    case 'ui/SAVED_TIME_UPDATED': {
      const { time } = payload;
      return { ...state, savedTime: time };
    }

    default:
      return state;
  };
};

export default UiReducer;



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/UiReducer.js